var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSplicing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4976_8513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5417 24.125H18.6667M26.1667 24.125H29.6667M39.6667 24.125H42.1667M50.1667 24.125H53.6667M63.6667 24.125H65.7918",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5417 56.125H21.6667M29.1667 56.125H34.1667M44.1667 56.125H49.1667M59.1667 56.125H65.7917",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1667 53C49.1667 52.4477 49.6144 52 50.1667 52H55.8342C56.1597 52 56.4648 52.1584 56.6521 52.4247L58.7621 55.4247C59.0048 55.7698 59.0048 56.2302 58.7621 56.5753L56.6521 59.5753C56.4648 59.8416 56.1597 60 55.8341 60H50.1667C49.6144 60 49.1667 59.5523 49.1667 59V53Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6667 21C53.6667 20.4477 54.1144 20 54.6667 20H60.3342C60.6597 20 60.9648 20.1584 61.1521 20.4247L63.2621 23.4247C63.5048 23.7698 63.5048 24.2302 63.2621 24.5753L61.1521 27.5753C60.9648 27.8416 60.6597 28 60.3341 28H54.6667C54.1144 28 53.6667 27.5523 53.6667 27V21Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1667 53C34.1667 52.4477 34.6144 52 35.1667 52H40.8342C41.1597 52 41.4648 52.1584 41.6521 52.4247L43.7621 55.4247C44.0048 55.7698 44.0048 56.2302 43.7621 56.5753L41.6521 59.5753C41.4648 59.8416 41.1597 60 40.8341 60H35.1667C34.6144 60 34.1667 59.5523 34.1667 59V53Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6667 21C29.6667 20.4477 30.1144 20 30.6667 20H36.3342C36.6597 20 36.9648 20.1584 37.1521 20.4247L39.2621 23.4247C39.5048 23.7698 39.5048 24.2302 39.2621 24.5753L37.1521 27.5753C36.9648 27.8416 36.6597 28 36.3341 28H30.6667C30.1144 28 29.6667 27.5523 29.6667 27V21Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 53C21.6667 52.4477 22.1144 52 22.6667 52H25.8342C26.1597 52 26.4648 52.1584 26.6521 52.4247L28.7621 55.4247C29.0048 55.7698 29.0048 56.2302 28.7621 56.5753L26.6521 59.5753C26.4648 59.8416 26.1597 60 25.8341 60H22.6667C22.1144 60 21.6667 59.5523 21.6667 59V53Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 21C18.6667 20.4477 19.1144 20 19.6667 20H22.8342C23.1597 20 23.4648 20.1584 23.6521 20.4247L25.7621 23.4247C26.0048 23.7698 26.0048 24.2302 25.7621 24.5753L23.6521 27.5753C23.4648 27.8416 23.1597 28 22.8341 28H19.6667C19.1144 28 18.6667 27.5523 18.6667 27V21Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6667 21C42.6667 20.4477 43.1144 20 43.6667 20H46.8342C47.1597 20 47.4648 20.1584 47.6521 20.4247L49.7621 23.4247C50.0048 23.7698 50.0048 24.2302 49.7621 24.5753L47.6521 27.5753C47.4648 27.8416 47.1597 28 46.8341 28H43.6667C43.1144 28 42.6667 27.5523 42.6667 27V21Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1667 31.5V40H25.6667V47.5",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2855 47.6187C28.6272 47.277 28.6272 46.723 28.2855 46.3813C27.9438 46.0396 27.3897 46.0396 27.048 46.3813L28.2855 47.6187ZM25.6667 49L25.048 49.6187C25.3897 49.9604 25.9438 49.9604 26.2855 49.6187L25.6667 49ZM24.2855 46.3813C23.9438 46.0396 23.3897 46.0396 23.048 46.3813C22.7063 46.723 22.7063 47.277 23.048 47.6187L24.2855 46.3813ZM27.048 46.3813L25.048 48.3813L26.2855 49.6187L28.2855 47.6187L27.048 46.3813ZM26.2855 48.3813L24.2855 46.3813L23.048 47.6187L25.048 49.6187L26.2855 48.3813Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5452 31.5V40H38.0452V47.5",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6639 47.6187C41.0056 47.277 41.0056 46.723 40.6639 46.3813C40.3222 46.0396 39.7682 46.0396 39.4264 46.3813L40.6639 47.6187ZM38.0452 49L37.4264 49.6187C37.7682 49.9604 38.3222 49.9604 38.6639 49.6187L38.0452 49ZM36.6639 46.3813C36.3222 46.0396 35.7682 46.0396 35.4264 46.3813C35.0847 46.723 35.0847 47.277 35.4264 47.6187L36.6639 46.3813ZM39.4264 46.3813L37.4264 48.3813L38.6639 49.6187L40.6639 47.6187L39.4264 46.3813ZM38.6639 48.3813L36.6639 46.3813L35.4264 47.6187L37.4264 49.6187L38.6639 48.3813Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.61 31.5V40H53.11V47.5",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4913 47.6187C50.1496 47.277 50.1496 46.723 50.4913 46.3813C50.833 46.0396 51.3871 46.0396 51.7288 46.3813L50.4913 47.6187ZM53.11 49L53.7288 49.6187C53.3871 49.9604 52.833 49.9604 52.4913 49.6187L53.11 49ZM54.4913 46.3813C54.833 46.0396 55.3871 46.0396 55.7288 46.3813C56.0705 46.723 56.0705 47.277 55.7288 47.6187L54.4913 46.3813ZM51.7288 46.3813L53.7288 48.3813L52.4913 49.6187L50.4913 47.6187L51.7288 46.3813ZM52.4913 48.3813L54.4913 46.3813L55.7288 47.6187L53.7288 49.6187L52.4913 48.3813Z",
    fill: "#161616"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4976_8513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.666687)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplicing);
export default __webpack_public_path__ + "static/media/splicing.bed37b1657d3e56e016a232f8086818a.svg";
export { ForwardRef as ReactComponent };